import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { BarChartByProps } from '../config';
import { ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { saveFilters, setConfigGroups } from '@customer/store/slices/filtersSlice';
import { useGetConfigurationGroupsQuery } from '@customer/store/apis/configurationGroupsApi';

export const BarChartByConfigGroup = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const dispatch = useAppDispatch();
  const siteId = useAppSelector(state => state.auth.siteId);

  const { data: configGroups } = useGetConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const isConfigGroupValid = useCallback(
    (configGroupId: number): boolean => {
      return (
        typeof configGroups !== 'undefined' &&
        configGroups.some(group => group.id === configGroupId)
      );
    },
    [configGroups],
  );

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ id: configGroupId }: CustomBarChartLabel): void => {
      // Confirm that the selected config group is within the list provided by the API.
      if (siteId && isConfigGroupValid(configGroupId)) {
        dispatch(setConfigGroups([configGroupId.toString()]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId, isConfigGroupValid],
  );

  return (
    <BarChartScenario<T>
      {...props}
      onCategorySelect={onCategorySelect}
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByConfigGroup;
